import {BaseCachedService} from './Core/BaseCachedService';
import {ArrayUtils} from "../Utils";

class ConfirmationStatusService extends BaseCachedService {
    get ModelName() { return "Confirmation Status"; }
    get PrimaryKeyProperty() { return "confirmationStatusId"; }
    get Url() { return super.Url + "/confirmationStatus"; }

    Get() {
        return super.Get().then((confirmationStatuses) => {
                if (confirmationStatuses.result) {
                    confirmationStatuses.result = confirmationStatuses.result
                        .sort(ArrayUtils.SortToBottom((x) => x.code == 'on-hold' ));
                }

                return confirmationStatuses;
            }
        );
    }

}

export const service = new ConfirmationStatusService();

